interface TrustBarProps {
  trustItems?: { icon: string; label: string }[];
}

const defaultTrustItems = [
  { icon: 'ri-shield-check-fill', label: 'Safety-First Instruction' },
  { icon: 'ri-anchor-line', label: 'Waterfront Dive Center — Pier 5' },
  { icon: 'ri-map-pin-2-fill', label: 'Miami — 401 Biscayne Blvd' },
  { icon: 'ri-user-star-fill', label: 'Expert Certified Instructors' },
  { icon: 'ri-ship-line', label: 'Real Boat. Real Ocean.' },
];

const agencies = [
  { label: 'PADI', full: 'Professional Association' },
  { label: 'SSI', full: 'Scuba Schools Intl' },
  { label: 'SDI', full: 'Scuba Diving Intl' },
  { label: 'TDI', full: 'Technical Diving Intl' },
  { label: 'ERDI', full: 'Emergency Response' },
];

export default function SectionTrustBar({ trustItems = defaultTrustItems }: TrustBarProps) {
  return (
    <section className="bg-[#0A1628] border-y border-white/8 relative overflow-hidden">
      {/* Subtle glow behind agencies */}
      <div className="absolute inset-0 opacity-[0.03]" style={{ background: 'radial-gradient(ellipse 60% 100% at 50% 0%, #00B4D8, transparent)' }} />

      {/* Agency accreditations row */}
      <div className="relative border-b border-white/8">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-wrap items-center justify-center gap-0">
            <span className="text-white/20 text-[10px] font-bold uppercase tracking-[0.3em] mr-8 shrink-0 hidden lg:block">
              Certified By
            </span>
            {agencies.map((ag, i) => (
              <div key={ag.label} className="flex items-center">
                <div className="flex flex-col items-center px-6 py-1 group cursor-default">
                  <span
                    className="text-white font-black text-xl tracking-widest leading-none group-hover:text-[#00B4D8] transition-colors duration-300"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {ag.label}
                  </span>
                  <span className="text-[#00B4D8]/50 text-[8px] uppercase tracking-[0.2em] mt-0.5 font-semibold whitespace-nowrap">
                    {ag.full}
                  </span>
                </div>
                {i < agencies.length - 1 && (
                  <div className="h-8 w-px bg-white/10 hidden sm:block" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Trust proof statements row */}
      <div className="relative max-w-7xl mx-auto px-6 py-5">
        <div className="flex flex-wrap items-center justify-center gap-0">
          {trustItems.map((item, i) => (
            <div key={item.label} className="flex items-center">
              <div className="flex items-center gap-2.5 px-5 py-1 group cursor-default">
                <div className="w-4 h-4 flex items-center justify-center shrink-0">
                  <i className={`${item.icon} text-[#00B4D8] text-sm`} />
                </div>
                <span className="text-white/50 text-[12px] font-semibold tracking-wide whitespace-nowrap group-hover:text-white/80 transition-colors">
                  {item.label}
                </span>
              </div>
              {i < trustItems.length - 1 && (
                <div className="h-3.5 w-px bg-white/10 hidden md:block" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
